module.exports = __webpack_public_path__ + "static/img/gdym03.dc12ae1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/gdym03.png
// module id = uURl
// module chunks = 0